import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteLineListComponent } from './quote-line-list/quote-line-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonPipesModule } from '@quorum/common-pipes';

@NgModule({
  imports: [
    CommonModule,
    CommonPipesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule
  ],
  declarations: [QuoteLineListComponent],
  exports: [QuoteLineListComponent]
})
export class ShaServiceQuotesNgUiModule {}
